// import { CommonModule } from "@angular/common";

import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from "@angular/core";
import { RouterModule } from "@angular/router";
// import { RouterModule } from "@angular/router";
import { BoardCard } from "@fry/boards/lib";
import { BookingModule } from "@fry/booking/app";
import { FryCommonModule } from "@fry/components/common";
import { InteractiveTableModule } from "@fry/components/common/list/interactive-table";
import { InteractiveTableOptions } from "@fry/components/common/list/interactive-table/interactive-table.component";
import { MaterialModule } from "@fry/components/material";
import { AuthService } from "@fry/lib/auth";
import { ListDefaults, TableService } from "@fry/lib/list";
import { UserService } from "@fry/lib/users";
import { UnboxedModule } from "@fry/ui";
import { tap } from "rxjs";
import { BookingAvailableCardOptions } from "./booking-available-card.interface";
import { BookingAvailableCardSourceFactory } from "./booking-available-card.source";

@Component({
    selector: "eas-booking-available-card",
    templateUrl: "./booking-available-card.view.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    RouterModule,
    FryCommonModule,
    UnboxedModule,
    BookingModule,
    InteractiveTableModule,
    MaterialModule
],
    providers: [
        TableService,
    ]
})
export class BookingAvailableCardViewComponent {

    card = input.required<BoardCard>();

    static key = "BookingAvailableCardViewComponent";

    private tableService = inject(TableService);
    private sourceFactory = inject(BookingAvailableCardSourceFactory);
    private auth = inject(AuthService);
    private userService = inject(UserService, { optional: true});

    $searchModel = this.tableService.$mergedSearchModel;

    tableLoaded = signal<boolean>(false);

    $title = computed(() => this.card().options.title || '');
    $options = computed(() => this.card().options as BookingAvailableCardOptions);

    public tableComponentOptions: InteractiveTableOptions = {
        enableColumns: false,
        enableFilters: true,
        enablePagination: false,
        enableExpand: true,
        enableControls: false,
        expand: {
            label: $localize `Title`,
            type: "modal",
            modalType: "bookingApply"
        }
    };

    ngOnInit() {
        this.initializeTable().subscribe({
            error: (error) => {
                console.error(error);
            }
        });
    }

    initializeTable() {
        const pageSize = 1000;
        const defaults: ListDefaults = { listType: 'table', engine: 'es', pageSize: pageSize, preserveState: false };
        this.tableComponentOptions.enableControls = this.$options().options?.hideControls !== true;
        this.tableComponentOptions.context = {
            user: this.userService ? this.userService.user.doc.username : this.auth.current.username
        };
        defaults.fixedSearchModel = {
            filter: {
            },
            sort: { sort_on: 'order', sort_order: 'asc' },
            // select: ['bookingItem', 'bookingOption', 'createdDate', 'preview'],
            options: {
                // includeFormFields: false
            },
            context: {
                filter: {},
                user: this.userService ? this.userService.user.doc.username : this.auth.current.username
            }
        }
        defaults.searchModel = this.$options().searchModel;
        defaults.featuredFilters = ['text'];
        defaults.quickFilters = ['windowState'];

        if (!this.auth.isLoggedIn) {
            defaults.hideFilters = ['eligible'];
        }
        const source = this.sourceFactory.getTableSource(this.card().boardId, this.card().id);
        return this.tableService.setupWith(source, defaults, 'available-card')
            .pipe(tap(() => this.tableLoaded.set(true)));
    }
}
